import React, { useRef, useState } from 'react'

import GuestJourneyContext from 'contexts/GuestJourneyContext'
import useAuthGuest from 'hooks/useAuthGuest'

const GuestJourneyProvider = ({ guestModule, redirectPath, children }) => {
  const { company, linkInvalid, portalToken } = useAuthGuest()

  const [activeStep, setActiveStep] = useState(0)
  const [accessToken, setAccessToken] = useState(null)
  const [user, setUser] = useState(null)
  const [recaptcha, setRecaptcha] = useState()

  const recaptchaRef = useRef(null)

  const handleNext = () => setActiveStep((prev) => prev + 1)

  const resetRecaptcha = () => {
    if (recaptchaRef.current) recaptchaRef.current.reset()
    setRecaptcha(undefined)
  }

  const handleAcceptedRecaptcha = (token) => setRecaptcha(token)
  const disableRecaptcha = () => setRecaptcha(undefined)

  return (
    <GuestJourneyContext.Provider
      value={{
        accessToken,
        activeStep,
        companyInfo: company,
        disableRecaptcha,
        guestModule,
        handleAcceptedRecaptcha,
        handleNext,
        linkInvalid,
        portalToken,
        recaptcha,
        recaptchaRef,
        redirectPath,
        resetRecaptcha,
        setAccessToken,
        setActiveStep,
        setUser,
        user,
      }}
    >
      {children}
    </GuestJourneyContext.Provider>
  )
}

export default GuestJourneyProvider
